import script from "./AnimatedRouterView.vue?vue&type=script&setup=true&lang=js"
export * from "./AnimatedRouterView.vue?vue&type=script&setup=true&lang=js"

import "./AnimatedRouterView.vue?vue&type=style&index=0&id=38c45b4c&lang=css"

const __exports__ = script;

export default __exports__